/** @file makeContext: the CommandContext of one batch (seeded ids and randomness, default tables). */
import { BUILTIN_PROFILES } from '@zilo/pose3d-format/tables/builtinProfiles';
import { SECTOR_TABLES } from '@zilo/pose3d-format/tables/sectorTables';
import { makeId } from '@zilo/pose3d-std/ids/makeId';
import type { Batch } from '../types/batch';
import type { CommandContext } from './commandContext';
import { makeRandom } from './makeRandom';

/** What the caller supplies: the packer, and any stores and tables that differ from the defaults. */
export type ContextExtras = Partial<Pick<CommandContext, 'profiles' | 'sectorTables' | 'images' | 'templates' | 'libraries' | 'puppets'>>
  & Pick<CommandContext, 'packShelves'>;

/** The context of `batch`: random = mulberry32(seed), ids from `now` and that source, built-in profiles and tables. */
export function makeContext(batch: Batch, extras: ContextExtras): CommandContext {
  const random = makeRandom(batch.seed);
  return {
    now: batch.now, seed: batch.seed, actor: batch.actor, random, makeId: (prefix) => makeId(prefix, batch.now, random),
    profiles: { ...BUILTIN_PROFILES }, sectorTables: { ...SECTOR_TABLES }, images: {}, templates: {}, libraries: {}, puppets: {},
    ...extras,
  };
}
